import { render, staticRenderFns } from "./biaoshi.vue?vue&type=template&id=5d924ec0&scoped=true&"
import script from "./biaoshi.vue?vue&type=script&lang=js&"
export * from "./biaoshi.vue?vue&type=script&lang=js&"
import style0 from "./biaoshi.vue?vue&type=style&index=0&id=5d924ec0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d924ec0",
  null
  
)

export default component.exports